/* ============================================================
   NOBS & CO — Quick-add das coleções/cards
   Intercepta o "Adicionar ao carrinho" dos cards do Dawn (que usam
   o custom element <product-form>) e redireciona pro drawer novo,
   em vez do carrinho antigo do tema.
   ============================================================ */
(function () {
  'use strict';

  if (window.__nobsQuickAdd) return;
  window.__nobsQuickAdd = true;

  function refreshBubble() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (c) {
        var target = document.getElementById('cart-icon-bubble');
        if (!target) return;
        var bubble = target.querySelector('.cart-count-bubble');
        if (c.item_count > 0) {
          if (!bubble) {
            bubble = document.createElement('div');
            bubble.className = 'cart-count-bubble';
            target.appendChild(bubble);
          }
          bubble.innerHTML = '<span aria-hidden="true">' + (c.item_count < 100 ? c.item_count : '99') + '</span>';
        } else if (bubble) {
          bubble.parentNode.removeChild(bubble);
        }
      })
      .catch(function () {});
  }

  function openDrawer() {
    if (window.NobsCart && typeof window.NobsCart.openRefreshed === 'function') {
      window.NobsCart.openRefreshed();
    }
  }

  // Captura o submit dos formulários de card (dentro de <product-form>) antes
  // do handler do Dawn rodar, e faz a adição via AJAX no nosso fluxo.
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || form.tagName !== 'FORM') return;
    var pf = form.closest('product-form');
    if (!pf) return; // só os cards do Dawn; nossas seções não usam <product-form>

    e.preventDefault();
    e.stopImmediatePropagation();

    var btn = form.querySelector('[type="submit"]');
    var original = btn ? btn.innerHTML : '';
    if (btn) btn.setAttribute('aria-disabled', 'true');

    var body = new FormData(form);
    fetch('/cart/add.js', { method: 'POST', body: body })
      .then(function (r) {
        if (!r.ok) throw new Error('add failed');
        return r.json();
      })
      .then(function () {
        refreshBubble();
        openDrawer();
        if (btn) btn.removeAttribute('aria-disabled');
      })
      .catch(function () {
        // se falhar, deixa o card seguir o comportamento normal do Dawn
        if (btn) btn.removeAttribute('aria-disabled');
        form.submit();
      });
  }, true);
})();
